import ActionTypes from './types'

export const setDisabledFeatures = (dispatch, disabledFeatures) => {
  dispatch({
    type: ActionTypes.SET_DISABLED_FEATURES,
    payload: disabledFeatures,
  })
}
